export default {"src":"/_next/static/media/pirl.8491b077.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};